import SettingFrame from "../../../../components/@settings/SettingFrame";
import NewShippingRule from "../../../../components/@shipping/shipping_rules/NewShippingRule";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ShippingRuleNewPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <NewShippingRule
                routeType={routeType}
            />
        </SettingFrame>
    )
}       